module.exports = __webpack_public_path__ + "img/stop_btn.95906072.png";